
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: bf0e5e8a04cada8225617067eaa03d041e2bba36
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "bf0e5e8a04cada8225617067eaa03d041e2bba36"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image'
};

exports.Prisma.UserAppleMigrationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  sub: 'sub'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.CacheScalarFieldEnum = {
  model: 'model',
  operation: 'operation',
  key: 'key',
  value: 'value',
  created: 'created',
  updated: 'updated'
};

exports.Prisma.ProfileScalarFieldEnum = {
  id: 'id',
  shortid: 'shortid',
  name: 'name',
  surname: 'surname',
  email: 'email',
  description: 'description',
  countrycode: 'countrycode',
  current_region: 'current_region',
  gaClientId: 'gaClientId',
  invited_by: 'invited_by',
  balance: 'balance',
  ruby: 'ruby',
  type: 'type',
  isArtClubMember: 'isArtClubMember',
  isPopular: 'isPopular',
  referralLevel: 'referralLevel',
  isFeedbackCompleted: 'isFeedbackCompleted'
};

exports.Prisma.BlockScalarFieldEnum = {
  id: 'id',
  blockerId: 'blockerId',
  blockedId: 'blockedId',
  createdAt: 'createdAt'
};

exports.Prisma.ReferralSystemScalarFieldEnum = {
  profileId: 'profileId',
  type: 'type',
  bonuses: 'bonuses'
};

exports.Prisma.ShippingRequestScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  toyId: 'toyId',
  quantity: 'quantity',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  countryCode: 'countryCode',
  region: 'region',
  city: 'city',
  postalCode: 'postalCode',
  street: 'street',
  house: 'house',
  building: 'building',
  apartment: 'apartment',
  comments: 'comments',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AnalyticsInfoScalarFieldEnum = {
  id: 'id',
  gaClientId: 'gaClientId',
  adformId: 'adformId',
  createdAt: 'createdAt',
  profileId: 'profileId',
  utm: 'utm'
};

exports.Prisma.SocialToyShareScalarFieldEnum = {
  id: 'id',
  isGoldRewarded: 'isGoldRewarded',
  ownerReward: 'ownerReward',
  shortId: 'shortId',
  profileId: 'profileId',
  toyId: 'toyId',
  shareCode: 'shareCode',
  refShortLink: 'refShortLink',
  publicatedTo: 'publicatedTo',
  socialLink: 'socialLink',
  confirmed: 'confirmed',
  sharedAt: 'sharedAt',
  createdAt: 'createdAt',
  assignmentComplete: 'assignmentComplete'
};

exports.Prisma.TweetScalarFieldEnum = {
  id: 'id',
  avatarid: 'avatarid',
  nickname: 'nickname',
  title: 'title',
  content: 'content'
};

exports.Prisma.BanScalarFieldEnum = {
  profileid: 'profileid',
  accounts: 'accounts',
  sessions: 'sessions',
  shortid: 'shortid',
  type: 'type',
  reason: 'reason'
};

exports.Prisma.ProfileAwardScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  parentId: 'parentId',
  parentLevel: 'parentLevel',
  award: 'award',
  idempotencyKey: 'idempotencyKey',
  currency: 'currency',
  price: 'price',
  created: 'created'
};

exports.Prisma.NovuFeedScalarFieldEnum = {
  transactionId: 'transactionId',
  trigger: 'trigger',
  profileId: 'profileId',
  idempotencyKey: 'idempotencyKey'
};

exports.Prisma.SocialScalarFieldEnum = {
  profileId: 'profileId',
  provider: 'provider',
  meta: 'meta',
  created: 'created'
};

exports.Prisma.StatsScalarFieldEnum = {
  profileId: 'profileId',
  level: 'level',
  achivements: 'achivements'
};

exports.Prisma.LeaderboardScalarFieldEnum = {
  profileId: 'profileId',
  ownerships: 'ownerships',
  charge: 'charge',
  burn: 'burn',
  period: 'period'
};

exports.Prisma.AvatarScalarFieldEnum = {
  profileId: 'profileId',
  id: 'id',
  isCopiedToBunny: 'isCopiedToBunny'
};

exports.Prisma.UploadIntentScalarFieldEnum = {
  profileId: 'profileId',
  fileId: 'fileId',
  uri: 'uri'
};

exports.Prisma.MetamaskWalletScalarFieldEnum = {
  profileId: 'profileId',
  walletid: 'walletid'
};

exports.Prisma.KycDataScalarFieldEnum = {
  profileId: 'profileId',
  isIdentityVerified: 'isIdentityVerified',
  status: 'status',
  result: 'result',
  applicantId: 'applicantId',
  updatedAt: 'updatedAt'
};

exports.Prisma.StripeProfileScalarFieldEnum = {
  profileId: 'profileId',
  stripeId: 'stripeId'
};

exports.Prisma.RarityScalarFieldEnum = {
  id: 'id',
  label: 'label',
  range: 'range',
  from: 'from',
  to: 'to',
  amount: 'amount'
};

exports.Prisma.BurnRateByRarityScalarFieldEnum = {
  rarityId: 'rarityId',
  reward: 'reward'
};

exports.Prisma.BalanceDailySnapshotScalarFieldEnum = {
  date: 'date',
  value: 'value'
};

exports.Prisma.ToyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  countrycode: 'countrycode',
  publishdate: 'publishdate',
  supplied: 'supplied',
  reserved: 'reserved',
  imageid: 'imageid',
  raritytype: 'raritytype',
  authorid: 'authorid',
  likescount: 'likescount',
  owned: 'owned',
  available: 'available',
  burned: 'burned',
  description: 'description',
  slug: 'slug',
  tags: 'tags',
  internalSearchTags: 'internalSearchTags',
  backgroundColor: 'backgroundColor',
  fontColor: 'fontColor',
  visible: 'visible',
  public: 'public',
  retroDropsEnabled: 'retroDropsEnabled',
  mintable: 'mintable',
  publication: 'publication',
  badges: 'badges',
  draftId: 'draftId',
  packId: 'packId',
  preview: 'preview'
};

exports.Prisma.TimerScalarFieldEnum = {
  id: 'id',
  toyId: 'toyId',
  trigger: 'trigger',
  updated: 'updated',
  type: 'type',
  status: 'status'
};

exports.Prisma.OpenEditionScalarFieldEnum = {
  id: 'id',
  toyId: 'toyId',
  startAt: 'startAt',
  closeAt: 'closeAt',
  supplied: 'supplied'
};

exports.Prisma.ToyDraftScalarFieldEnum = {
  id: 'id',
  name: 'name',
  imageId: 'imageId',
  modelId: 'modelId',
  modelId_usdz: 'modelId_usdz',
  raritytype: 'raritytype',
  description: 'description',
  supplied: 'supplied',
  artistId: 'artistId',
  publication: 'publication',
  status: 'status',
  created: 'created',
  updated: 'updated',
  socials: 'socials',
  digital_drop_price: 'digital_drop_price',
  digital_drop_currency: 'digital_drop_currency',
  adminNote: 'adminNote'
};

exports.Prisma.PromoScalarFieldEnum = {
  id: 'id',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  backgroundImageId: 'backgroundImageId',
  foregroundImageId: 'foregroundImageId',
  buttonTitle: 'buttonTitle',
  buttonUri: 'buttonUri',
  color: 'color',
  start: 'start',
  finish: 'finish',
  created: 'created',
  updated: 'updated',
  timer: 'timer',
  dropid: 'dropid',
  userType: 'userType'
};

exports.Prisma.ArtistMetaScalarFieldEnum = {
  toyId: 'toyId',
  isEnabled: 'isEnabled',
  position: 'position',
  id: 'id'
};

exports.Prisma.Model3dScalarFieldEnum = {
  toyId: 'toyId',
  archiveName: 'archiveName',
  hash: 'hash',
  provider: 'provider'
};

exports.Prisma.ArtistScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  name: 'name',
  description: 'description',
  signatureid: 'signatureid',
  statistic: 'statistic',
  created: 'created',
  popularity: 'popularity',
  socials: 'socials',
  draftId: 'draftId',
  visible: 'visible'
};

exports.Prisma.ArtistDraftScalarFieldEnum = {
  id: 'id',
  shortid: 'shortid',
  name: 'name',
  surname: 'surname',
  email: 'email',
  description: 'description',
  socials: 'socials',
  profileId: 'profileId',
  status: 'status',
  adminNote: 'adminNote'
};

exports.Prisma.ArtistAttachmentScalarFieldEnum = {
  id: 'id',
  artistId: 'artistId',
  type: 'type',
  attachmentId: 'attachmentId'
};

exports.Prisma.CollectionMetaScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  imageid: 'imageid',
  toysPublished: 'toysPublished',
  toysTotal: 'toysTotal',
  slug: 'slug',
  popularity: 'popularity',
  ofTheWeek: 'ofTheWeek',
  authorid: 'authorid',
  draftId: 'draftId',
  created: 'created',
  updated_at: 'updated_at'
};

exports.Prisma.InCollectionDraftScalarFieldEnum = {
  toyid: 'toyid',
  collectionid: 'collectionid',
  id: 'id'
};

exports.Prisma.CollectionBonusDraftScalarFieldEnum = {
  toyid: 'toyid',
  collectionid: 'collectionid',
  id: 'id'
};

exports.Prisma.CollectionMetaDraftScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  imageid: 'imageid',
  toysTotal: 'toysTotal',
  slug: 'slug',
  authorid: 'authorid',
  status: 'status',
  statusLoadImage: 'statusLoadImage',
  messege: 'messege',
  created: 'created',
  updated: 'updated'
};

exports.Prisma.MintSetupScalarFieldEnum = {
  id: 'id',
  contractId: 'contractId',
  price: 'price',
  currency: 'currency',
  collectionId: 'collectionId'
};

exports.Prisma.CollectionOrderScalarFieldEnum = {
  id: 'id',
  collectionId: 'collectionId',
  value: 'value'
};

exports.Prisma.CollectionBonusOrderScalarFieldEnum = {
  id: 'id',
  collectionId: 'collectionId',
  value: 'value'
};

exports.Prisma.InCollectionScalarFieldEnum = {
  toyid: 'toyid',
  collectionid: 'collectionid',
  id: 'id'
};

exports.Prisma.CollectionBonusScalarFieldEnum = {
  toyid: 'toyid',
  collectionid: 'collectionid',
  id: 'id'
};

exports.Prisma.CollectionBonusEarningScalarFieldEnum = {
  toyId: 'toyId',
  profileId: 'profileId'
};

exports.Prisma.DropScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  created: 'created',
  finish: 'finish',
  start: 'start',
  mechanic: 'mechanic',
  alternativeCollect: 'alternativeCollect',
  toyid: 'toyid',
  order: 'order',
  price: 'price',
  currency: 'currency',
  allowedCountries: 'allowedCountries'
};

exports.Prisma.DropAllowedAfterAdScalarFieldEnum = {
  id: 'id',
  dropId: 'dropId',
  profileId: 'profileId',
  created: 'created'
};

exports.Prisma.AdsVideosScalarFieldEnum = {
  id: 'id',
  videoId: 'videoId',
  name: 'name',
  dropId: 'dropId'
};

exports.Prisma.ActionToCollectScalarFieldEnum = {
  id: 'id',
  artistId: 'artistId',
  name: 'name',
  dropId: 'dropId'
};

exports.Prisma.SecretCodeScalarFieldEnum = {
  id: 'id',
  dropId: 'dropId',
  code: 'code',
  groupId: 'groupId',
  groupIdAdmin: 'groupIdAdmin'
};

exports.Prisma.SecretCodeInGroupScalarFieldEnum = {
  id: 'id',
  artistId: 'artistId',
  amount: 'amount',
  created: 'created'
};

exports.Prisma.SecretCodeInGroupAdminScalarFieldEnum = {
  id: 'id',
  name: 'name',
  dropId: 'dropId',
  amount: 'amount',
  created: 'created'
};

exports.Prisma.DropEarningScalarFieldEnum = {
  profileid: 'profileid',
  dropid: 'dropid',
  id: 'id'
};

exports.Prisma.JournalScalarFieldEnum = {
  from: 'from',
  to: 'to',
  valueref: 'valueref',
  amount: 'amount',
  timestamp: 'timestamp',
  comment: 'comment',
  id: 'id',
  operation: 'operation',
  valuetype: 'valuetype',
  meta: 'meta'
};

exports.Prisma.OwnershipScalarFieldEnum = {
  id: 'id',
  profileid: 'profileid',
  toyid: 'toyid',
  meta: 'meta',
  instanceid: 'instanceid',
  updated: 'updated'
};

exports.Prisma.BurnedOwnershipScalarFieldEnum = {
  id: 'id',
  profileid: 'profileid',
  toyid: 'toyid',
  meta: 'meta',
  instanceid: 'instanceid',
  updated: 'updated',
  storeItemId: 'storeItemId'
};

exports.Prisma.DropOwnershipsScalarFieldEnum = {
  id: 'id',
  profileid: 'profileid',
  toyid: 'toyid',
  reason: 'reason',
  idempotencyKey: 'idempotencyKey',
  meta: 'meta'
};

exports.Prisma.StoreItemScalarFieldEnum = {
  id: 'id',
  toyid: 'toyid',
  ownershipId: 'ownershipId',
  price: 'price',
  currency: 'currency',
  published: 'published',
  instanceid: 'instanceid',
  visible: 'visible',
  digitalDropId: 'digitalDropId'
};

exports.Prisma.DigitalDropScalarFieldEnum = {
  id: 'id',
  toyid: 'toyid',
  artistid: 'artistid',
  price: 'price',
  currency: 'currency',
  validFrom: 'validFrom',
  validUntil: 'validUntil'
};

exports.Prisma.OfferScalarFieldEnum = {
  id: 'id',
  profileid: 'profileid',
  toyid: 'toyid',
  price: 'price',
  currency: 'currency',
  created: 'created',
  instanceid: 'instanceid'
};

exports.Prisma.OnHoldScalarFieldEnum = {
  profileid: 'profileid',
  currency: 'currency',
  amount: 'amount'
};

exports.Prisma.InWishlistScalarFieldEnum = {
  profileid: 'profileid',
  toyid: 'toyid'
};

exports.Prisma.LikeScalarFieldEnum = {
  profileid: 'profileid',
  toyid: 'toyid'
};

exports.Prisma.BannerScalarFieldEnum = {
  id: 'id',
  cdnId: 'cdnId',
  url: 'url',
  cdnMobileId: 'cdnMobileId',
  isDefault: 'isDefault',
  isEnabled: 'isEnabled',
  isForceEnabled: 'isForceEnabled',
  isOpenInNewWindow: 'isOpenInNewWindow',
  queryParameters: 'queryParameters',
  region: 'region',
  backgroundColor: 'backgroundColor'
};

exports.Prisma.CustomBannerScalarFieldEnum = {
  id: 'id',
  type: 'type',
  visible: 'visible',
  dropId: 'dropId',
  productId: 'productId',
  collectionId: 'collectionId'
};

exports.Prisma.BannerScheduleScalarFieldEnum = {
  bannerId: 'bannerId',
  start: 'start',
  end: 'end',
  id: 'id'
};

exports.Prisma.PurchaseScalarFieldEnum = {
  id: 'id',
  profileShortID: 'profileShortID',
  referralShortId: 'referralShortId',
  toyId: 'toyId',
  instanceId: 'instanceId',
  subscriptionId: 'subscriptionId',
  rackId: 'rackId',
  packId: 'packId',
  award: 'award',
  dropMechanic: 'dropMechanic',
  provider: 'provider',
  sellerId: 'sellerId',
  authorId: 'authorId',
  price: 'price',
  currency: 'currency',
  storeItemId: 'storeItemId',
  offerId: 'offerId',
  date: 'date',
  blindBoxId: 'blindBoxId',
  type: 'type'
};

exports.Prisma.RouteScalarFieldEnum = {
  id: 'id',
  path: 'path',
  locale: 'locale'
};

exports.Prisma.MetaScalarFieldEnum = {
  id: 'id',
  name: 'name',
  routeId: 'routeId',
  title: 'title',
  description: 'description',
  keyWords: 'keyWords',
  otherData: 'otherData'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  transactionId: 'transactionId',
  transactionStatus: 'transactionStatus',
  moneyAmount: 'moneyAmount',
  goldAmount: 'goldAmount',
  history: 'history',
  timestamp: 'timestamp',
  service: 'service'
};

exports.Prisma.CollectedToysCacheScalarFieldEnum = {
  profileId: 'profileId',
  count: 'count',
  collectionId: 'collectionId'
};

exports.Prisma.BlindBoxScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created: 'created',
  blindBoxItemId: 'blindBoxItemId',
  modalText: 'modalText',
  link: 'link',
  visible: 'visible',
  active: 'active',
  price: 'price',
  currency: 'currency'
};

exports.Prisma.BlindBoxToysScalarFieldEnum = {
  id: 'id',
  toyId: 'toyId',
  blindBoxId: 'blindBoxId',
  probability: 'probability',
  secret: 'secret'
};

exports.Prisma.ApiLogScalarFieldEnum = {
  id: 'id',
  created: 'created',
  profileId: 'profileId',
  endpoint: 'endpoint',
  ip: 'ip',
  status: 'status'
};

exports.Prisma.ToyCounterScalarFieldEnum = {
  toyId: 'toyId',
  likes: 'likes',
  wishlists: 'wishlists'
};

exports.Prisma.ProfileAliasScalarFieldEnum = {
  alias: 'alias',
  profileId: 'profileId'
};

exports.Prisma.CompetitionScalarFieldEnum = {
  id: 'id',
  entries: 'entries',
  name: 'name',
  description: 'description',
  created: 'created',
  start: 'start',
  finish: 'finish',
  reporting: 'reporting',
  active: 'active'
};

exports.Prisma.CompetitionCodeScalarFieldEnum = {
  code: 'code',
  competitionId: 'competitionId',
  profileId: 'profileId',
  activated: 'activated',
  created: 'created'
};

exports.Prisma.FeedScalarFieldEnum = {
  id: 'id',
  event: 'event',
  source: 'source',
  title: 'title',
  description: 'description',
  body: 'body',
  imageid: 'imageid',
  backgroundId: 'backgroundId',
  uri: 'uri',
  created: 'created',
  actorId: 'actorId',
  shortId: 'shortId',
  toyId: 'toyId',
  artistId: 'artistId',
  purchaseId: 'purchaseId',
  collectionId: 'collectionId',
  achivement: 'achivement',
  userType: 'userType'
};

exports.Prisma.FeedTriggerScalarFieldEnum = {
  transactionId: 'transactionId',
  feedId: 'feedId',
  profileId: 'profileId'
};

exports.Prisma.RackScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  name: 'name',
  inversion: 'inversion',
  variationid: 'variationid',
  type: 'type',
  theme: 'theme'
};

exports.Prisma.RackMemberScalarFieldEnum = {
  rackId: 'rackId',
  toyId: 'toyId',
  position: 'position'
};

exports.Prisma.TinderScalarFieldEnum = {
  profileId: 'profileId',
  toyId: 'toyId',
  positive: 'positive',
  updated: 'updated'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  status: 'status',
  plan: 'plan',
  service: 'service',
  created: 'created',
  isPendingFinish: 'isPendingFinish',
  externalId: 'externalId',
  meta: 'meta'
};

exports.Prisma.SellerWhiteListScalarFieldEnum = {
  profileId: 'profileId'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  productId: 'productId',
  status: 'status',
  created: 'created',
  price: 'price',
  operator: 'operator',
  couponId: 'couponId'
};

exports.Prisma.ChargeScalarFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  status: 'status',
  created: 'created'
};

exports.Prisma.InvoiceProductScalarFieldEnum = {
  invoiceId: 'invoiceId',
  productId: 'productId',
  quantity: 'quantity'
};

exports.Prisma.MobilePaymentScalarFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  token: 'token',
  store: 'store',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  toyid: 'toyid',
  toyExpires: 'toyExpires',
  goldAmount: 'goldAmount',
  ruby: 'ruby',
  plan: 'plan',
  pass: 'pass',
  currentPrice: 'currentPrice',
  imageId: 'imageId',
  visible: 'visible',
  isWelcome: 'isWelcome',
  recommended: 'recommended',
  priority: 'priority'
};

exports.Prisma.StripeCouponScalarFieldEnum = {
  id: 'id',
  stripeCouponId: 'stripeCouponId',
  couponId: 'couponId',
  percentOff: 'percentOff',
  duration: 'duration'
};

exports.Prisma.CouponScalarFieldEnum = {
  id: 'id',
  code: 'code',
  discountPercentage: 'discountPercentage',
  isActive: 'isActive',
  singleUse: 'singleUse',
  requiresSubscription: 'requiresSubscription',
  rewardType: 'rewardType',
  purchaseLimit: 'purchaseLimit',
  minimumSpendThreshold: 'minimumSpendThreshold',
  validFrom: 'validFrom',
  validUntil: 'validUntil',
  profileId: 'profileId',
  currencyType: 'currencyType',
  isReusable: 'isReusable'
};

exports.Prisma.CouponUsageScalarFieldEnum = {
  id: 'id',
  couponId: 'couponId',
  profileId: 'profileId',
  orderValue: 'orderValue',
  usedAt: 'usedAt'
};

exports.Prisma.PromoCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  used: 'used',
  productId: 'productId',
  created: 'created',
  redeemedTime: 'redeemedTime',
  redeemedByProfileId: 'redeemedByProfileId'
};

exports.Prisma.RetroEarningScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  toyId: 'toyId',
  created: 'created',
  idempotencyKey: 'idempotencyKey'
};

exports.Prisma.RetroSkipScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  price: 'price',
  hours: 'hours',
  created: 'created',
  retroEarningId: 'retroEarningId'
};

exports.Prisma.ChangeLogScalarFieldEnum = {
  id: 'id',
  entityName: 'entityName',
  entityId: 'entityId',
  oldValue: 'oldValue',
  newValue: 'newValue',
  delta: 'delta',
  CRUDType: 'CRUDType',
  changedBy: 'changedBy',
  changedAt: 'changedAt'
};

exports.Prisma.SiriusPassScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  active: 'active',
  created: 'created',
  updated: 'updated'
};

exports.Prisma.PayoutScalarFieldEnum = {
  id: 'id',
  price: 'price',
  profileId: 'profileId',
  country: 'country',
  holderName: 'holderName',
  bankName: 'bankName',
  accountNumber: 'accountNumber',
  iban: 'iban',
  swiftCode: 'swiftCode',
  created: 'created',
  updated: 'updated',
  status: 'status'
};

exports.Prisma.PartnerScalarFieldEnum = {
  id: 'id',
  collectionId: 'collectionId',
  name: 'name',
  visible: 'visible'
};

exports.Prisma.PartnerDropContentScalarFieldEnum = {
  id: 'id',
  partnerId: 'partnerId',
  info: 'info',
  gift: 'gift',
  collected: 'collected',
  drop: 'drop',
  landingLink: 'landingLink',
  partnerDropMainBannerSmall: 'partnerDropMainBannerSmall',
  partnerDropPopup_desktop: 'partnerDropPopup_desktop',
  partnerDropPopup_mobile: 'partnerDropPopup_mobile',
  partnerDropCardBackCover: 'partnerDropCardBackCover',
  partnerDropLogo: 'partnerDropLogo',
  partnerDropSecondLogo: 'partnerDropSecondLogo',
  partnerDropPageBackground_desktop: 'partnerDropPageBackground_desktop',
  partnerDropPageBackground_mobile: 'partnerDropPageBackground_mobile'
};

exports.Prisma.PackScalarFieldEnum = {
  id: 'id',
  collectionId: 'collectionId',
  title: 'title',
  price: 'price',
  currency: 'currency',
  dropCount: 'dropCount',
  imageId: 'imageId',
  dropBGImageId: 'dropBGImageId'
};

exports.Prisma.PackRateScalarFieldEnum = {
  packId: 'packId',
  rarityId: 'rarityId',
  rate: 'rate'
};

exports.Prisma.PartnerLineScalarFieldEnum = {
  id: 'id',
  partnerId: 'partnerId',
  mechanic: 'mechanic',
  digitalOpenDate: 'digitalOpenDate'
};

exports.Prisma.PartnerRarityLineRequirementScalarFieldEnum = {
  id: 'id',
  partnerLineId: 'partnerLineId',
  rarityId: 'rarityId',
  position: 'position'
};

exports.Prisma.PartnerLineEarningScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  toyId: 'toyId',
  partnerLineId: 'partnerLineId'
};

exports.Prisma.CurrencyRatesToUSDScalarFieldEnum = {
  id: 'id',
  currency: 'currency',
  value: 'value',
  updateTime: 'updateTime'
};

exports.Prisma.ContractScalarFieldEnum = {
  id: 'id',
  address: 'address',
  chainId: 'chainId',
  chainName: 'chainName',
  exploreUrl: 'exploreUrl',
  providerUrl: 'providerUrl'
};

exports.Prisma.NftScalarFieldEnum = {
  ownershipId: 'ownershipId',
  tokenId: 'tokenId',
  owner: 'owner',
  contractId: 'contractId',
  created: 'created',
  updated: 'updated'
};

exports.Prisma.TransferScalarFieldEnum = {
  trxId: 'trxId',
  from: 'from',
  to: 'to',
  nftId: 'nftId',
  created: 'created'
};

exports.Prisma.WalletScalarFieldEnum = {
  profileId: 'profileId',
  address: 'address'
};

exports.Prisma.QuestScalarFieldEnum = {
  id: 'id',
  mechanicId: 'mechanicId',
  rewardId: 'rewardId',
  visibility: 'visibility',
  finish: 'finish',
  enabled: 'enabled'
};

exports.Prisma.QuestMechanicScalarFieldEnum = {
  id: 'id',
  artistId: 'artistId',
  activity: 'activity'
};

exports.Prisma.QuestRewardScalarFieldEnum = {
  id: 'id',
  toyId: 'toyId',
  amount: 'amount',
  currency: 'currency',
  plan: 'plan'
};

exports.Prisma.SeasonScalarFieldEnum = {
  id: 'id',
  toyId: 'toyId',
  start: 'start',
  finish: 'finish'
};

exports.Prisma.PostScalarFieldEnum = {
  id: 'id',
  content: 'content',
  content_new: 'content_new',
  title: 'title',
  type: 'type',
  created_at: 'created_at',
  edited_at: 'edited_at',
  publish_date: 'publish_date',
  published: 'published',
  media_url: 'media_url',
  media_type: 'media_type',
  author_id: 'author_id'
};

exports.Prisma.Post_viewsScalarFieldEnum = {
  id: 'id',
  post_id: 'post_id',
  created_at: 'created_at',
  profile_id: 'profile_id',
  hash: 'hash'
};

exports.Prisma.Post_reactionScalarFieldEnum = {
  id: 'id',
  post_id: 'post_id',
  type: 'type',
  created_at: 'created_at',
  profile_id: 'profile_id'
};

exports.Prisma.NewsScalarFieldEnum = {
  id: 'id',
  type: 'type',
  avatar_url: 'avatar_url',
  avatar_title: 'avatar_title',
  background_url: 'background_url',
  background_color: 'background_color',
  title: 'title',
  subtitle: 'subtitle',
  link: 'link',
  link_title: 'link_title',
  link_type: 'link_type'
};

exports.Prisma.ReportScalarFieldEnum = {
  id: 'id',
  senderId: 'senderId',
  targetId: 'targetId',
  reason: 'reason',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  postId: 'postId'
};

exports.Prisma.QuizScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  quiz: 'quiz',
  convenient: 'convenient',
  comment: 'comment',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.accountOrderByRelevanceFieldEnum = {
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.sessionOrderByRelevanceFieldEnum = {
  sessionToken: 'sessionToken'
};

exports.Prisma.userOrderByRelevanceFieldEnum = {
  name: 'name',
  email: 'email',
  image: 'image'
};

exports.Prisma.userAppleMigrationOrderByRelevanceFieldEnum = {
  name: 'name',
  email: 'email',
  image: 'image',
  sub: 'sub'
};

exports.Prisma.verificationTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.cacheOrderByRelevanceFieldEnum = {
  model: 'model',
  operation: 'operation'
};

exports.Prisma.profileOrderByRelevanceFieldEnum = {
  shortid: 'shortid',
  name: 'name',
  surname: 'surname',
  email: 'email',
  description: 'description',
  countrycode: 'countrycode',
  current_region: 'current_region',
  gaClientId: 'gaClientId'
};

exports.Prisma.shippingRequestOrderByRelevanceFieldEnum = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  countryCode: 'countryCode',
  region: 'region',
  city: 'city',
  postalCode: 'postalCode',
  street: 'street',
  house: 'house',
  building: 'building',
  apartment: 'apartment',
  comments: 'comments'
};

exports.Prisma.analyticsInfoOrderByRelevanceFieldEnum = {
  gaClientId: 'gaClientId',
  adformId: 'adformId'
};

exports.Prisma.socialToyShareOrderByRelevanceFieldEnum = {
  shortId: 'shortId',
  shareCode: 'shareCode',
  refShortLink: 'refShortLink',
  socialLink: 'socialLink'
};

exports.Prisma.tweetOrderByRelevanceFieldEnum = {
  avatarid: 'avatarid',
  nickname: 'nickname',
  title: 'title',
  content: 'content'
};

exports.Prisma.banOrderByRelevanceFieldEnum = {
  shortid: 'shortid',
  reason: 'reason'
};

exports.Prisma.profileAwardOrderByRelevanceFieldEnum = {
  idempotencyKey: 'idempotencyKey'
};

exports.Prisma.novuFeedOrderByRelevanceFieldEnum = {
  transactionId: 'transactionId',
  trigger: 'trigger',
  idempotencyKey: 'idempotencyKey'
};

exports.Prisma.avatarOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.uploadIntentOrderByRelevanceFieldEnum = {
  fileId: 'fileId',
  uri: 'uri'
};

exports.Prisma.metamaskWalletOrderByRelevanceFieldEnum = {
  walletid: 'walletid'
};

exports.Prisma.kycDataOrderByRelevanceFieldEnum = {
  applicantId: 'applicantId'
};

exports.Prisma.stripeProfileOrderByRelevanceFieldEnum = {
  stripeId: 'stripeId'
};

exports.Prisma.rarityOrderByRelevanceFieldEnum = {
  label: 'label',
  range: 'range'
};

exports.Prisma.toyOrderByRelevanceFieldEnum = {
  name: 'name',
  countrycode: 'countrycode',
  imageid: 'imageid',
  description: 'description',
  slug: 'slug',
  tags: 'tags',
  internalSearchTags: 'internalSearchTags',
  backgroundColor: 'backgroundColor',
  fontColor: 'fontColor'
};

exports.Prisma.toyDraftOrderByRelevanceFieldEnum = {
  name: 'name',
  imageId: 'imageId',
  modelId: 'modelId',
  modelId_usdz: 'modelId_usdz',
  description: 'description',
  adminNote: 'adminNote'
};

exports.Prisma.promoOrderByRelevanceFieldEnum = {
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  backgroundImageId: 'backgroundImageId',
  foregroundImageId: 'foregroundImageId',
  buttonTitle: 'buttonTitle',
  buttonUri: 'buttonUri',
  color: 'color',
  userType: 'userType'
};

exports.Prisma.model3dOrderByRelevanceFieldEnum = {
  archiveName: 'archiveName',
  hash: 'hash',
  provider: 'provider'
};

exports.Prisma.artistOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  signatureid: 'signatureid'
};

exports.Prisma.artistDraftOrderByRelevanceFieldEnum = {
  shortid: 'shortid',
  name: 'name',
  surname: 'surname',
  email: 'email',
  description: 'description',
  adminNote: 'adminNote'
};

exports.Prisma.artistAttachmentOrderByRelevanceFieldEnum = {
  attachmentId: 'attachmentId'
};

exports.Prisma.collectionMetaOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  imageid: 'imageid',
  slug: 'slug'
};

exports.Prisma.collectionMetaDraftOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  imageid: 'imageid',
  slug: 'slug',
  messege: 'messege'
};

exports.Prisma.dropOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  allowedCountries: 'allowedCountries'
};

exports.Prisma.adsVideosOrderByRelevanceFieldEnum = {
  videoId: 'videoId',
  name: 'name'
};

exports.Prisma.actionToCollectOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.secretCodeOrderByRelevanceFieldEnum = {
  code: 'code'
};

exports.Prisma.secretCodeInGroupAdminOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.journalOrderByRelevanceFieldEnum = {
  comment: 'comment'
};

exports.Prisma.bannerOrderByRelevanceFieldEnum = {
  id: 'id',
  cdnId: 'cdnId',
  url: 'url',
  cdnMobileId: 'cdnMobileId',
  queryParameters: 'queryParameters',
  region: 'region',
  backgroundColor: 'backgroundColor'
};

exports.Prisma.bannerScheduleOrderByRelevanceFieldEnum = {
  bannerId: 'bannerId'
};

exports.Prisma.purchaseOrderByRelevanceFieldEnum = {
  profileShortID: 'profileShortID',
  referralShortId: 'referralShortId'
};

exports.Prisma.routeOrderByRelevanceFieldEnum = {
  id: 'id',
  path: 'path',
  locale: 'locale'
};

exports.Prisma.metaOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  routeId: 'routeId',
  title: 'title',
  description: 'description',
  keyWords: 'keyWords'
};

exports.Prisma.paymentOrderByRelevanceFieldEnum = {
  transactionId: 'transactionId'
};

exports.Prisma.blindBoxOrderByRelevanceFieldEnum = {
  name: 'name',
  link: 'link'
};

exports.Prisma.apiLogOrderByRelevanceFieldEnum = {
  endpoint: 'endpoint',
  ip: 'ip'
};

exports.Prisma.profileAliasOrderByRelevanceFieldEnum = {
  alias: 'alias'
};

exports.Prisma.competitionOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description'
};

exports.Prisma.competitionCodeOrderByRelevanceFieldEnum = {
  code: 'code',
  competitionId: 'competitionId'
};

exports.Prisma.feedOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  imageid: 'imageid',
  backgroundId: 'backgroundId',
  uri: 'uri',
  shortId: 'shortId',
  userType: 'userType'
};

exports.Prisma.feedTriggerOrderByRelevanceFieldEnum = {
  transactionId: 'transactionId'
};

exports.Prisma.rackOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.subscriptionOrderByRelevanceFieldEnum = {
  externalId: 'externalId'
};

exports.Prisma.invoiceOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.chargeOrderByRelevanceFieldEnum = {
  invoiceId: 'invoiceId'
};

exports.Prisma.invoiceProductOrderByRelevanceFieldEnum = {
  invoiceId: 'invoiceId'
};

exports.Prisma.mobilePaymentOrderByRelevanceFieldEnum = {
  invoiceId: 'invoiceId',
  token: 'token'
};

exports.Prisma.productOrderByRelevanceFieldEnum = {
  imageId: 'imageId'
};

exports.Prisma.stripeCouponOrderByRelevanceFieldEnum = {
  stripeCouponId: 'stripeCouponId'
};

exports.Prisma.couponOrderByRelevanceFieldEnum = {
  code: 'code'
};

exports.Prisma.promoCodeOrderByRelevanceFieldEnum = {
  code: 'code'
};

exports.Prisma.retroEarningOrderByRelevanceFieldEnum = {
  idempotencyKey: 'idempotencyKey'
};

exports.Prisma.changeLogOrderByRelevanceFieldEnum = {
  entityName: 'entityName',
  entityId: 'entityId'
};

exports.Prisma.payoutOrderByRelevanceFieldEnum = {
  country: 'country',
  holderName: 'holderName',
  bankName: 'bankName',
  accountNumber: 'accountNumber',
  iban: 'iban',
  swiftCode: 'swiftCode'
};

exports.Prisma.partnerOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.partnerDropContentOrderByRelevanceFieldEnum = {
  landingLink: 'landingLink',
  partnerDropMainBannerSmall: 'partnerDropMainBannerSmall',
  partnerDropPopup_desktop: 'partnerDropPopup_desktop',
  partnerDropPopup_mobile: 'partnerDropPopup_mobile',
  partnerDropCardBackCover: 'partnerDropCardBackCover',
  partnerDropLogo: 'partnerDropLogo',
  partnerDropSecondLogo: 'partnerDropSecondLogo',
  partnerDropPageBackground_desktop: 'partnerDropPageBackground_desktop',
  partnerDropPageBackground_mobile: 'partnerDropPageBackground_mobile'
};

exports.Prisma.packOrderByRelevanceFieldEnum = {
  imageId: 'imageId',
  dropBGImageId: 'dropBGImageId'
};

exports.Prisma.contractOrderByRelevanceFieldEnum = {
  address: 'address',
  chainId: 'chainId',
  chainName: 'chainName',
  exploreUrl: 'exploreUrl',
  providerUrl: 'providerUrl'
};

exports.Prisma.nftOrderByRelevanceFieldEnum = {
  owner: 'owner'
};

exports.Prisma.transferOrderByRelevanceFieldEnum = {
  trxId: 'trxId',
  from: 'from',
  to: 'to'
};

exports.Prisma.walletOrderByRelevanceFieldEnum = {
  address: 'address'
};

exports.Prisma.postOrderByRelevanceFieldEnum = {
  content: 'content',
  title: 'title',
  media_url: 'media_url'
};

exports.Prisma.post_viewsOrderByRelevanceFieldEnum = {
  hash: 'hash'
};

exports.Prisma.newsOrderByRelevanceFieldEnum = {
  avatar_url: 'avatar_url',
  avatar_title: 'avatar_title',
  background_url: 'background_url',
  background_color: 'background_color',
  title: 'title',
  subtitle: 'subtitle',
  link: 'link',
  link_title: 'link_title'
};

exports.Prisma.quizOrderByRelevanceFieldEnum = {
  comment: 'comment'
};
exports.ProfileType = exports.$Enums.ProfileType = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  ADMIN: 'ADMIN',
  MODERATOR: 'MODERATOR',
  EMPLOYEE: 'EMPLOYEE',
  PARTNER: 'PARTNER',
  HIDDEN_USER: 'HIDDEN_USER',
  BLOCKCHAIN_GUEST: 'BLOCKCHAIN_GUEST'
};

exports.ReferreeType = exports.$Enums.ReferreeType = {
  COMMON: 'COMMON',
  PRIVILEGED: 'PRIVILEGED'
};

exports.ShippingRequestStatus = exports.$Enums.ShippingRequestStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED'
};

exports.provider = exports.$Enums.provider = {
  facebook: 'facebook',
  google: 'google',
  tiktok: 'tiktok',
  telegram: 'telegram',
  vk: 'vk',
  discord: 'discord',
  instagram: 'instagram',
  x: 'x'
};

exports.award = exports.$Enums.award = {
  REFFERAL_5DROPS: 'REFFERAL_5DROPS',
  REFERRAL_INVITE: 'REFERRAL_INVITE',
  REFERRAL_SUBSCRIBTION: 'REFERRAL_SUBSCRIBTION',
  REFERRAL_SUBSCRIBTION_MONTH: 'REFERRAL_SUBSCRIBTION_MONTH',
  REFERRAL_SUBSCRIBTION_HALF_YEAR: 'REFERRAL_SUBSCRIBTION_HALF_YEAR',
  REFERRAL_SUBSCRIBTION_YEAR: 'REFERRAL_SUBSCRIBTION_YEAR',
  REFERRAL_GOLD_PURCHASE: 'REFERRAL_GOLD_PURCHASE'
};

exports.ValueTypes = exports.$Enums.ValueTypes = {
  GOLD: 'GOLD',
  TOY: 'TOY',
  MONEY: 'MONEY',
  RUBY: 'RUBY'
};

exports.ProfileLevel = exports.$Enums.ProfileLevel = {
  Common: 'Common',
  Rare: 'Rare',
  SuperRare: 'SuperRare',
  Epic: 'Epic',
  Legendary: 'Legendary',
  Mythical: 'Mythical',
  OneAndOnly: 'OneAndOnly'
};

exports.achivement = exports.$Enums.achivement = {
  FirstSteps: 'FirstSteps',
  RareGem: 'RareGem',
  TreasureHunter: 'TreasureHunter',
  EpicDiscovery: 'EpicDiscovery',
  LegendUnearthed: 'LegendUnearthed',
  MythicalEncounter: 'MythicalEncounter',
  OneOfAKind: 'OneOfAKind',
  DedicatedCollector: 'DedicatedCollector',
  TrueEnthusiast: 'TrueEnthusiast',
  CollectorExtraordinaire: 'CollectorExtraordinaire',
  TradingProdigy: 'TradingProdigy',
  MasterTrader: 'MasterTrader',
  RaritySacrifice: 'RaritySacrifice',
  TradingLegend: 'TradingLegend',
  SocialButterfly: 'SocialButterfly',
  NetworkingExpert: 'NetworkingExpert',
  CompleteSet: 'CompleteSet',
  SetConnoisseur: 'SetConnoisseur',
  AshesToAshes: 'AshesToAshes',
  FireStarter: 'FireStarter',
  CleansingFlames: 'CleansingFlames',
  InfernoMaster: 'InfernoMaster',
  BonfireConnoisseur: 'BonfireConnoisseur',
  LordOfEmbers: 'LordOfEmbers',
  SuperRarePyre: 'SuperRarePyre',
  EpicOffering: 'EpicOffering',
  LegendaryCremation: 'LegendaryCremation',
  MythicalBlaze: 'MythicalBlaze',
  SolemnFarewell: 'SolemnFarewell',
  BalancedBurn: 'BalancedBurn',
  SetAblaze: 'SetAblaze',
  ScorchedCollection: 'ScorchedCollection',
  JackOfAllTrades: 'JackOfAllTrades',
  ChikoRokoFanatic: 'ChikoRokoFanatic',
  ChikoRokoConqueror: 'ChikoRokoConqueror'
};

exports.period = exports.$Enums.period = {
  yesterday: 'yesterday',
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
  total: 'total'
};

exports.ReviewStatus = exports.$Enums.ReviewStatus = {
  init: 'init',
  pending: 'pending',
  prechecked: 'prechecked',
  queued: 'queued',
  completed: 'completed'
};

exports.ReviewResult = exports.$Enums.ReviewResult = {
  GREEN: 'GREEN',
  RED: 'RED'
};

exports.PublicationType = exports.$Enums.PublicationType = {
  DROP: 'DROP',
  DIGITAL: 'DIGITAL',
  TWIN: 'TWIN'
};

exports.badge = exports.$Enums.badge = {
  artClub: 'artClub',
  gift: 'gift',
  animated: 'animated',
  digitalTwin: 'digitalTwin',
  blindbox: 'blindbox'
};

exports.TimerType = exports.$Enums.TimerType = {
  visibility: 'visibility'
};

exports.TimerStatus = exports.$Enums.TimerStatus = {
  PLANNED: 'PLANNED',
  FINISHED: 'FINISHED',
  DISABLED: 'DISABLED'
};

exports.ToyDraftStatus = exports.$Enums.ToyDraftStatus = {
  NEW: 'NEW',
  REJECTED: 'REJECTED',
  IN_MODERATION: 'IN_MODERATION',
  APPROVED: 'APPROVED',
  EXPORTED: 'EXPORTED'
};

exports.ArtistDraftStatus = exports.$Enums.ArtistDraftStatus = {
  APPROVED: 'APPROVED',
  IN_MODERATION: 'IN_MODERATION',
  RELEASED: 'RELEASED',
  CREATED: 'CREATED',
  REJECTED: 'REJECTED'
};

exports.AttachmentType = exports.$Enums.AttachmentType = {
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE'
};

exports.CollectionMetaDraftStatus = exports.$Enums.CollectionMetaDraftStatus = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  IN_MODERATION: 'IN_MODERATION',
  CREATED: 'CREATED'
};

exports.CollectionMetaDraftLoadImageStatus = exports.$Enums.CollectionMetaDraftLoadImageStatus = {
  PROCESS: 'PROCESS',
  FINISHED: 'FINISHED'
};

exports.DropMechanics = exports.$Enums.DropMechanics = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  ARTCLUB: 'ARTCLUB',
  GIFT: 'GIFT',
  SECRET: 'SECRET',
  BLINDBOX: 'BLINDBOX',
  SECRET_PERSONAL: 'SECRET_PERSONAL',
  ONBOARDING: 'ONBOARDING',
  COLLECTION_BONUS: 'COLLECTION_BONUS',
  PARTNER: 'PARTNER',
  RETRO: 'RETRO',
  BUY: 'BUY',
  QUEST: 'QUEST',
  BLINDBOX_RESERVATION: 'BLINDBOX_RESERVATION',
  BLINDBOX_FULLSET: 'BLINDBOX_FULLSET',
  BLINDBOX_OPEN: 'BLINDBOX_OPEN',
  DIGITAL: 'DIGITAL'
};

exports.AlternativeCollects = exports.$Enums.AlternativeCollects = {
  FALSE: 'FALSE',
  COMPETITION: 'COMPETITION',
  ADS: 'ADS',
  ARTIST_SUBSCRIPTION: 'ARTIST_SUBSCRIPTION'
};

exports.OperationTypes = exports.$Enums.OperationTypes = {
  PURCHASE_COMMUNITY_STORE: 'PURCHASE_COMMUNITY_STORE',
  PURCHASE_INTERNAL_STORE: 'PURCHASE_INTERNAL_STORE',
  EARN_COLLECTION_BONUS: 'EARN_COLLECTION_BONUS',
  EARN_DROP_ITEM: 'EARN_DROP_ITEM',
  ADMIN_EDIT: 'ADMIN_EDIT',
  REFFERAL_BONUS: 'REFFERAL_BONUS',
  PURCHASE_BLINDBOX: 'PURCHASE_BLINDBOX',
  MIGRATION: 'MIGRATION',
  COMISSION: 'COMISSION',
  PURCHASE_RACK: 'PURCHASE_RACK',
  PARTNER_PACK_PURCHASE: 'PARTNER_PACK_PURCHASE',
  BURN: 'BURN',
  SOCIAL_VERIFICATION: 'SOCIAL_VERIFICATION',
  PURCHASE_RETRO_SKIP: 'PURCHASE_RETRO_SKIP',
  REDEEM_PROMO_CODE: 'REDEEM_PROMO_CODE',
  SIRIUS_WITHDRAW: 'SIRIUS_WITHDRAW',
  SIRIUS_RESET_PASS: 'SIRIUS_RESET_PASS',
  SIRIUS_AWARD_WINNER: 'SIRIUS_AWARD_WINNER',
  PAYOUT: 'PAYOUT',
  SHARE_POST_24: 'SHARE_POST_24',
  SHARE_POST_REWARD: 'SHARE_POST_REWARD',
  COMISSION_TO_ARTIST: 'COMISSION_TO_ARTIST',
  HOLD_BY_OFFER: 'HOLD_BY_OFFER',
  PURCHASE_BY_OFFER: 'PURCHASE_BY_OFFER',
  CUSTOM_BANNERS: 'CUSTOM_BANNERS',
  TRANSFER_BY_NFT: 'TRANSFER_BY_NFT',
  EARN_QUEST: 'EARN_QUEST',
  BLINDBOX_RESERVATION: 'BLINDBOX_RESERVATION',
  BLINDBOX_COLLECT: 'BLINDBOX_COLLECT',
  BLINDBOX_FULLSET: 'BLINDBOX_FULLSET',
  BLINDBOX_OPEN: 'BLINDBOX_OPEN',
  DIGITAL_DROP: 'DIGITAL_DROP'
};

exports.OffersBannerTypes = exports.$Enums.OffersBannerTypes = {
  empty: 'empty',
  PRODUCT: 'PRODUCT',
  SUBSCRIPTION: 'SUBSCRIPTION',
  TOY: 'TOY',
  COLLECTION: 'COLLECTION'
};

exports.PurchaseTypes = exports.$Enums.PurchaseTypes = {
  CRON_COLLECT: 'CRON_COLLECT',
  PARTNER_PACK_PURCHASE: 'PARTNER_PACK_PURCHASE',
  PURCHASED_TOY: 'PURCHASED_TOY',
  COLLECTED_TOY: 'COLLECTED_TOY',
  BURNED_TOY: 'BURNED_TOY',
  GIFT_TOY: 'GIFT_TOY',
  PURCHASE: 'PURCHASE',
  WITHDRAW: 'WITHDRAW',
  COMMISSION: 'COMMISSION',
  COMMISSION_ARTIST: 'COMMISSION_ARTIST',
  SUBSCRIPTION: 'SUBSCRIPTION',
  SHARE: 'SHARE',
  CONFIRMATION_SHARING: 'CONFIRMATION_SHARING',
  BOUGHT_BOARD: 'BOUGHT_BOARD',
  BOUGHT_BOARD_BG: 'BOUGHT_BOARD_BG',
  REFERRAL: 'REFERRAL',
  BOUGHT_GAME: 'BOUGHT_GAME',
  GAME_WIN: 'GAME_WIN',
  SOCIAL_VERIFICATION: 'SOCIAL_VERIFICATION',
  USER_REGISTRATION: 'USER_REGISTRATION',
  SKIP_DROP: 'SKIP_DROP',
  ADMIN: 'ADMIN',
  PROMO_CODE: 'PROMO_CODE',
  MIGRATION: 'MIGRATION',
  OFFER_FROZEN: 'OFFER_FROZEN',
  OFFER_RETURNED: 'OFFER_RETURNED',
  CUSTOM_BANNERS: 'CUSTOM_BANNERS',
  QUEST_EARN: 'QUEST_EARN',
  BLINDBOX: 'BLINDBOX',
  PURCHASED_BLINDBOX_FULLSET: 'PURCHASED_BLINDBOX_FULLSET',
  BLINDBOX_OPEN: 'BLINDBOX_OPEN',
  MINT_FEE: 'MINT_FEE',
  RUBY_CASHBACK: 'RUBY_CASHBACK',
  DIGITAL_DROP: 'DIGITAL_DROP',
  ROYALTY_FOR_BUYABLE_DROP: 'ROYALTY_FOR_BUYABLE_DROP'
};

exports.TransactionStatus = exports.$Enums.TransactionStatus = {
  SUCCEED: 'SUCCEED',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
  CREATED: 'CREATED'
};

exports.PaymentService = exports.$Enums.PaymentService = {
  STRIPE: 'STRIPE',
  ROBOKASSA: 'ROBOKASSA',
  COINBASE: 'COINBASE',
  NIHAOPAY: 'NIHAOPAY',
  RUBY_PAY: 'RUBY_PAY',
  GOOGLE_PLAY: 'GOOGLE_PLAY',
  APPLE_STORE: 'APPLE_STORE'
};

exports.feed_event = exports.$Enums.feed_event = {
  post: 'post',
  earn: 'earn',
  bought: 'bought',
  sold: 'sold',
  follower: 'follower',
  burn: 'burn',
  collection: 'collection',
  completedAchivement: 'completedAchivement',
  completedSet: 'completedSet',
  collectedBonusToy: 'collectedBonusToy',
  artistToy: 'artistToy',
  artistSet: 'artistSet',
  artistTopSell: 'artistTopSell',
  shareReward: 'shareReward',
  shareOwnReward: 'shareOwnReward',
  referralLevel: 'referralLevel',
  referralBonus: 'referralBonus',
  artistRegistration: 'artistRegistration',
  artistToyCreate: 'artistToyCreate',
  artistSetCreate: 'artistSetCreate',
  artistFollowing: 'artistFollowing'
};

exports.feed_source = exports.$Enums.feed_source = {
  ChikoRoko: 'ChikoRoko',
  ArtToys: 'ArtToys',
  Artist: 'Artist',
  Profile: 'Profile'
};

exports.rackType = exports.$Enums.rackType = {
  free: 'free',
  purchase: 'purchase'
};

exports.rackTheme = exports.$Enums.rackTheme = {
  grey: 'grey',
  blue: 'blue',
  green: 'green',
  orange: 'orange',
  custom: 'custom'
};

exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  active: 'active',
  paused: 'paused',
  finished: 'finished'
};

exports.SubscriptionPlan = exports.$Enums.SubscriptionPlan = {
  month: 'month',
  sixMonths: 'sixMonths',
  year: 'year',
  lifetime: 'lifetime'
};

exports.InvoiceStatus = exports.$Enums.InvoiceStatus = {
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  PAYMENT_SUCCESSFUL: 'PAYMENT_SUCCESSFUL',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  DISPATCHED_SUCCESSFUL: 'DISPATCHED_SUCCESSFUL',
  DISPATCHED_FAILED: 'DISPATCHED_FAILED'
};

exports.StoreType = exports.$Enums.StoreType = {
  GOOGLE: 'GOOGLE',
  APPLE: 'APPLE'
};

exports.siriusPassProduct = exports.$Enums.siriusPassProduct = {
  currentSeason: 'currentSeason'
};

exports.StripeCouponDuration = exports.$Enums.StripeCouponDuration = {
  once: 'once',
  repeating: 'repeating',
  forever: 'forever'
};

exports.CouponRewardType = exports.$Enums.CouponRewardType = {
  DISCOUNT: 'DISCOUNT',
  RUBY_CASHBACK: 'RUBY_CASHBACK'
};

exports.ChangeLogCRUDType = exports.$Enums.ChangeLogCRUDType = {
  create: 'create',
  update: 'update',
  delete: 'delete',
  deleteMany: 'deleteMany'
};

exports.payoutStatus = exports.$Enums.payoutStatus = {
  approved: 'approved',
  declined: 'declined',
  review: 'review'
};

exports.LineMechanics = exports.$Enums.LineMechanics = {
  TOY: 'TOY',
  RARITY: 'RARITY'
};

exports.CURRENCY_CODE = exports.$Enums.CURRENCY_CODE = {
  HKD: 'HKD',
  RUB: 'RUB'
};

exports.questVisibility = exports.$Enums.questVisibility = {
  all: 'all',
  list: 'list'
};

exports.PostType = exports.$Enums.PostType = {
  NEWS: 'NEWS',
  PERSONAL: 'PERSONAL'
};

exports.PostMediaType = exports.$Enums.PostMediaType = {
  IMAGE: 'IMAGE'
};

exports.PostReactionType = exports.$Enums.PostReactionType = {
  HEART: 'HEART',
  FIRE: 'FIRE',
  NEUTURAL_FACE: 'NEUTURAL_FACE',
  POUTING_FACE: 'POUTING_FACE'
};

exports.NewsType = exports.$Enums.NewsType = {
  NEWS: 'NEWS',
  PERSONAL: 'PERSONAL'
};

exports.LinkType = exports.$Enums.LinkType = {
  LINK: 'LINK',
  BUTTON: 'BUTTON'
};

exports.ReportReason = exports.$Enums.ReportReason = {
  DISLIKE: 'DISLIKE',
  BULLYING: 'BULLYING',
  SELF_HARM: 'SELF_HARM',
  VIOLENCE: 'VIOLENCE',
  RESTRICTED_ITEMS: 'RESTRICTED_ITEMS',
  ADULT_CONTENT: 'ADULT_CONTENT',
  SCAM: 'SCAM',
  FALSE_INFORMATION: 'FALSE_INFORMATION'
};

exports.ReportStatus = exports.$Enums.ReportStatus = {
  PENDING: 'PENDING',
  REVIEWED: 'REVIEWED',
  RESOLVED: 'RESOLVED',
  DISMISSED: 'DISMISSED'
};

exports.Prisma.ModelName = {
  account: 'account',
  session: 'session',
  user: 'user',
  userAppleMigration: 'userAppleMigration',
  verificationToken: 'verificationToken',
  cache: 'cache',
  profile: 'profile',
  block: 'block',
  referralSystem: 'referralSystem',
  shippingRequest: 'shippingRequest',
  analyticsInfo: 'analyticsInfo',
  socialToyShare: 'socialToyShare',
  tweet: 'tweet',
  ban: 'ban',
  profileAward: 'profileAward',
  novuFeed: 'novuFeed',
  social: 'social',
  stats: 'stats',
  leaderboard: 'leaderboard',
  avatar: 'avatar',
  uploadIntent: 'uploadIntent',
  metamaskWallet: 'metamaskWallet',
  kycData: 'kycData',
  stripeProfile: 'stripeProfile',
  rarity: 'rarity',
  burnRateByRarity: 'burnRateByRarity',
  balanceDailySnapshot: 'balanceDailySnapshot',
  toy: 'toy',
  timer: 'timer',
  openEdition: 'openEdition',
  toyDraft: 'toyDraft',
  promo: 'promo',
  artistMeta: 'artistMeta',
  model3d: 'model3d',
  artist: 'artist',
  artistDraft: 'artistDraft',
  artistAttachment: 'artistAttachment',
  collectionMeta: 'collectionMeta',
  inCollectionDraft: 'inCollectionDraft',
  collectionBonusDraft: 'collectionBonusDraft',
  collectionMetaDraft: 'collectionMetaDraft',
  mintSetup: 'mintSetup',
  collectionOrder: 'collectionOrder',
  collectionBonusOrder: 'collectionBonusOrder',
  inCollection: 'inCollection',
  collectionBonus: 'collectionBonus',
  collectionBonusEarning: 'collectionBonusEarning',
  drop: 'drop',
  dropAllowedAfterAd: 'dropAllowedAfterAd',
  adsVideos: 'adsVideos',
  actionToCollect: 'actionToCollect',
  secretCode: 'secretCode',
  secretCodeInGroup: 'secretCodeInGroup',
  secretCodeInGroupAdmin: 'secretCodeInGroupAdmin',
  dropEarning: 'dropEarning',
  journal: 'journal',
  ownership: 'ownership',
  burnedOwnership: 'burnedOwnership',
  dropOwnerships: 'dropOwnerships',
  storeItem: 'storeItem',
  digitalDrop: 'digitalDrop',
  offer: 'offer',
  onHold: 'onHold',
  inWishlist: 'inWishlist',
  like: 'like',
  banner: 'banner',
  customBanner: 'customBanner',
  bannerSchedule: 'bannerSchedule',
  purchase: 'purchase',
  route: 'route',
  meta: 'meta',
  payment: 'payment',
  collectedToysCache: 'collectedToysCache',
  blindBox: 'blindBox',
  blindBoxToys: 'blindBoxToys',
  apiLog: 'apiLog',
  toyCounter: 'toyCounter',
  profileAlias: 'profileAlias',
  competition: 'competition',
  competitionCode: 'competitionCode',
  feed: 'feed',
  feedTrigger: 'feedTrigger',
  rack: 'rack',
  rackMember: 'rackMember',
  tinder: 'tinder',
  subscription: 'subscription',
  sellerWhiteList: 'sellerWhiteList',
  invoice: 'invoice',
  charge: 'charge',
  invoiceProduct: 'invoiceProduct',
  mobilePayment: 'mobilePayment',
  product: 'product',
  stripeCoupon: 'stripeCoupon',
  coupon: 'coupon',
  couponUsage: 'couponUsage',
  promoCode: 'promoCode',
  retroEarning: 'retroEarning',
  retroSkip: 'retroSkip',
  changeLog: 'changeLog',
  siriusPass: 'siriusPass',
  payout: 'payout',
  partner: 'partner',
  partnerDropContent: 'partnerDropContent',
  pack: 'pack',
  packRate: 'packRate',
  partnerLine: 'partnerLine',
  partnerRarityLineRequirement: 'partnerRarityLineRequirement',
  partnerLineEarning: 'partnerLineEarning',
  currencyRatesToUSD: 'currencyRatesToUSD',
  contract: 'contract',
  nft: 'nft',
  transfer: 'transfer',
  wallet: 'wallet',
  quest: 'quest',
  questMechanic: 'questMechanic',
  questReward: 'questReward',
  season: 'season',
  post: 'post',
  post_views: 'post_views',
  post_reaction: 'post_reaction',
  news: 'news',
  report: 'report',
  quiz: 'quiz'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
